










import {nextTick} from "process";
import ripple from "./ripple.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import { frontendClient } from "../lib/client";

@Component({
    components: {
        ripple,
    }
})
export default class userIcon extends Vue {
    @Prop({}) dark:boolean;
    
    isTooltipInvisible: boolean = false;
    image: string = null;
    name: string=null;

    mounted(){
        this.getImg();
        this.getUserChar();
    }

    getImg(){
        if(frontendClient.userData.displayImageURL != null) this.image = frontendClient.userData.displayImageURL;
    }

    async getUserChar(){
        let int = null;
        this.name = await (frontendClient.userData.fullName);
    }
}

